export function dataInRequest(params = {}) {
  return {
    type: '@recebimento/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@recebimento/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@recebimento/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@recebimento/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@recebimento/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@recebimento/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@recebimento/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@recebimento/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@recebimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@recebimento/RECORD_FILTERING',
    payload: { params },
  };
}
